import { createAction } from 'modules/redux-store';

export const dashboardAction = {
  success: (isDashboardOpen: boolean) =>
    createAction('dashboard/SUCCESS', { isDashboardOpen }),
};
